<template>
  <div class="pa-0">
    <!-- Search and Actions -->
    <v-row class="mb-4 align-center px-4">
      <v-col cols="12" md="6">
        <v-text-field
          v-model="search"
          label="Buscar familia..."
          prepend-inner-icon="fas fa-search"
          outlined
          dense
          hide-details
          clearable
          class="modern-search-field"
        ></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto">
        <v-btn color="primary" depressed @click="create" class="px-6">
          <v-icon left small>fas fa-plus</v-icon> Nueva Familia
        </v-btn>
      </v-col>
    </v-row>

    <!-- Table -->
    <v-card outlined class="modern-card elevation-0 overflow-hidden">
      <v-data-table
        :headers="headers"
        :items="families"
        :loading="loading"
        :search="search"
        sort-by="name"
        class="modern-table"
        :items-per-page="15"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageOptions: [10, 15, 30, 50]
        }"
      >
        <template v-slot:item.id="{ item }">
          <span class="caption grey--text font-weight-bold">#{{ item.id }}</span>
        </template>

        <template v-slot:item.name="{ item }">
          <span class="body-2 font-weight-bold primary--text">{{ item.name }}</span>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn icon small color="primary" @click.stop="edit(item)">
            <v-icon small>fas fa-edit</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <!-- Modal -->
    <v-dialog v-model="showDialog" max-width="500px" persistent>
      <v-card outlined class="modern-card overflow-hidden">
        <v-sheet color="grey lighten-4" class="px-6 py-4 border-bottom">
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-3">
              {{ newFamily.id > 0 ? 'fas fa-edit' : 'fas fa-plus-circle' }}
            </v-icon>
            <div>
              <div class="text-h6 font-weight-bold lh-1">
                {{ newFamily.id > 0 ? 'Actualizar Familia' : 'Nueva Familia' }}
              </div>
              <div class="caption grey--text mt-1">Configuración del catálogo de productos</div>
            </div>
          </div>
        </v-sheet>

        <v-card-text class="pa-6 pt-8">
          <ValidationObserver v-slot="{ handleSubmit }">
            <v-form @submit.prevent="handleSubmit(newFamily.id > 0 ? updateFamily : createFamily)">
              <ValidationProvider name="Nombre" rules="required" v-slot="{ errors }">
                <v-text-field
                  v-model="newFamily.name"
                  label="Nombre de la Familia"
                  placeholder="Ej: Impresión, Corte, etc."
                  outlined
                  dense
                  autofocus
                  hide-details="auto"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>

              <v-divider class="my-6"></v-divider>

              <div class="d-flex justify-end">
                <v-btn text small @click="showDialog = false" class="mr-2">Cancelar</v-btn>
                <v-btn type="submit" color="primary" depressed small class="px-6">
                  <v-icon x-small class="mr-2">fas fa-save</v-icon>
                  Guardar
                </v-btn>
              </div>
            </v-form>
          </ValidationObserver>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { fetchFamily, createFamily, updateFamily } from '@/api/products'
import notifications from '@/utils/notifications'

export default {
  name: 'Family',
  data: () => ({
    families: [],
    search: '',
    showDialog: false,
    loading: false,
    newFamily: { id: -1, name: '' },
    headers: [
      { text: 'ID', value: 'id', align: 'start', width: '80', class: 'grey lighten-4' },
      { text: 'Nombre de Familia', value: 'name', align: 'start', class: 'grey lighten-4' },
      { text: 'Acciones', value: 'actions', align: 'center', width: '100', sortable: false, class: 'grey lighten-4' }
    ],
  }),
  methods: {
    edit(item) {
      this.newFamily = { ...item }
      this.showDialog = true
    },
    create() {
      this.newFamily = { id: -1, name: '' }
      this.showDialog = true
    },
    async createFamily() {
      try {
        await createFamily(this.newFamily)
        notifications.showSuccess('Familia creada: ' + this.newFamily.name)
        this.showDialog = false
        this.refresh()
      } catch (e) {
        notifications.showError('Error al crear familia')
      }
    },
    async updateFamily() {
      try {
        await updateFamily(this.newFamily)
        notifications.showSuccess('Familia actualizada')
        this.showDialog = false
        this.refresh()
      } catch (e) {
        notifications.showError('Error al actualizar familia')
      }
    },
    async refresh() {
      this.loading = true
      const res = await fetchFamily()
      this.families = res
      this.$store.dispatch('getFamilies')
      this.loading = false
    }
  },
  async created() {
    this.refresh()
  }
}
</script>

<style scoped>
.modern-card {
  border: 1px solid rgba(0,0,0,0.08) !important;
  border-radius: 12px !important;
}
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.08); }
.lh-1 { line-height: 1.2; }
</style>
